import Cookie from "js-cookie";
import { COOKIE_LANG } from "customGlobal";

export function getUserLang() {
  return Cookie.get(COOKIE_LANG) || "fr";
}
